import { BETSLIP_VALIDATION_STATUS } from '../../constants'

export const sportsbookDefaultSettings = {
  feedStates: {},
  multiset: {
    allowed: false
  },
  conditional: {
    allowed: false
  },
  chain: {
    allowed: false
  },
  lucky: {
    allowed: false
  },
  single: {
    allowed: false
  },
  system: {
    allowed: false
  },
  complexSystem: {
    allowed: false
  },
  multiple: {
    allowed: false
  },
  maxOutcomeInBlock: null,
  asianAllowed: false,
  fractionalAllowed: false,
  integerAllowed: false,
  cashOut: false,
  editBet: false,
  orderBet: false,
  orderCashOut: false,
  partialCashOut: false
}

export const emptyGlobalBetslipState = {
  reports: [],
  initialized: false,
  pending: false,
  errors: {}
}

export const emptyBetslipState = {
  initialized: false,
  loading: false,
  active: false,
  suspended: false,
  fullfited: false,
  confirming: false,
  betItems: [],
  betTypes: [],
  betshash: '',
  bonuses: {},
  errors: {},
  outcomesErrors: {},
  limits: {},

  // FIXME: Rework betslip settings providing
  settings: sportsbookDefaultSettings,

  validationStatus: BETSLIP_VALIDATION_STATUS.WAITING_VALIDATION,

  bonusAssignments: []
}
